export enum Platform {
  SLACK = 'slack',
  EMAIL = 'email',
  TEAMS = 'teams',
  INSTAGRAM = 'instagram',
}

export interface PlatformState {
  platformSelected: Platform;
}
export interface PlatformActions {
  setPlatform: (platform: Platform) => void;
  resetState: () => void;
}

export type PlatformStore = PlatformState & PlatformActions;

export const INITIAL_PLATFORM_STATE: PlatformState = {
  platformSelected: Platform.EMAIL,
};
